import React, { useState, useEffect } from "react";
import { EditorHeader } from "./EditorHeader";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import "../assets/stylesheets/EditorPage.css";
import { useSearchParams } from "react-router-dom";
import ResizeModule from "@botom/quill-resize-module";
import { fontFamily, fontSizeArr, lineHeight, modules, formats } from '../configs/quillConfig'
import { WordCount } from "./WordCount";
import { stateContext } from "./Context";
import { FindandReplace } from "./FindandReplace";
import { Modal } from "./Modal";
import { paraPhrasing } from "./APICalls";
import loadingImg  from '../assets/images/loading.svg'
import $ from 'jquery'
window.jQuery = $;
// import all the jquery.ime rules
require('../configs/ime_rules')

	// find all occurance of a substring
	export const findAllOccurrences = (str, substr) => {
		str = str.toLowerCase();
		substr = substr.toLowerCase();
		let result = [];
		let idx = str.indexOf(substr);
		while (idx !== -1) {
			result.push(idx);
			idx = str.indexOf(substr, idx + 1);
		}
		return result;
	};

export const EditorPage = () => {

	$( document ).ready( function () {
		$( '[contenteditable]' ).ime();

	} );

	const { quill, quillRef } = useQuill({ modules, formats });
	// const { quill, quillRef, Quill } = useQuill({ modules, formats });

	// To add custom quill elements
	if (quill && !quill) {
		var Size = quill.import("attributors/style/size");
		Size.whitelist = fontSizeArr;
		quill.register(Size, true);

		quill.register("modules/resize", ResizeModule);
		quill.debug(false);

		var FontAttributor = quill.import("formats/font");
		FontAttributor.whitelist = fontFamily;
		quill.register(FontAttributor, true);

		var Parchment = quill.import('parchment');
		var lineHeightConfig = {
			scope: Parchment.Scope.INLINE,
			whitelist: lineHeight
		};
		var lineHeightClass = new Parchment.ClassAttributor('lineheight', 'ql-line-height', lineHeightConfig);
		var lineHeightStyle = new Parchment.StyleAttributor('lineheight', 'line-height', lineHeightConfig);
		quill.register(lineHeightStyle, true);
		quill.register(lineHeightClass, true);


		let Inline = quill.import('blots/inline');
		class SpanBlock extends Inline{    
			static create(value){
					let node = super.create();
					node.setAttribute('class','underline');
					return node;    
			} 
		}
		SpanBlock.blotName = 'spanblock';
		SpanBlock.tagName = 'div';
		quill.register(SpanBlock);

		let Block = quill.import('blots/block');
		class Hr extends Block {
			static create(value) {
				let node = super.create();
				node.setAttribute('style', "height:0px; margin-top:10px; margin-bottom:10px;");
				return node;
			}
		}
		Hr.blotName = 'hr'; 
		Hr.tagName = 'hr';
		quill.register(Hr);

		// Set icons to toolbar buttons
		var icons = quill.import('ui/icons');
		icons['hr'] = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 10h24v4h-24z"/></svg>';

	}
	
	

	// Get the correct index of words including images and videos
	const quillTextWithoutMedia = () => {
		return quill.getContents().filter(function (op) {
			return typeof op.insert === 'string' || op.insert.image || op.insert.video;
		}).map(function (op) {
			 if (op.insert.image) {
				return op.insert.image = 'i';
			}else if (op.insert.video) {
				return op.insert.video = 'i';         
			}
			return op.insert;
		}).join('');
	} 

	const [tableObj, setTableObj] = useState()

	// OnLoad load Arial font-family & 16px font-size
	useEffect(() => {
		if (quill) {
			
			// Default font style
			let qlFontPicker = document.getElementsByClassName('ql-font')[0];
			let qlFontPickerLable = qlFontPicker.childNodes[0];
			qlFontPickerLable.setAttribute("data-value", "Arial")
			
			// Default font size
			let qlSizePicker = document.getElementsByClassName("ql-size")[0];
			let qlPickerLabel = qlSizePicker.childNodes[0];
			qlPickerLabel.setAttribute("data-value", "16px");

			// Table creation module
			const table = quill.getModule('table');
			setTableObj(table)

			// code for not moving div to top on toolbar click
			let qlToolbar = document.getElementsByClassName('ql-toolbar')[0]
			qlToolbar.addEventListener('mousedown', (e) => {
				e.preventDefault();
				e.stopPropagation();
			})

			// Add Handler for toolbar buttons
			const toolbar = quill.getModule('toolbar')
			// Horizontal line handler
			toolbar.addHandler('hr',()=>{
				var range = quill.getSelection()
				if(range){
					quill.insertEmbed(range.index, 'hr', true)
				}
			})
			// Table handler
			toolbar.addHandler('table',() => {
				setTargetButton('Insert table')
				setShowModal(!showModal)
			})
			quill.focus();
		}
		
	}, [quill])


	//NER state variables
	// const [nerScrLangValue, setNerScrLangValue] = useState("en");
	const [namedEntities, setNamedEntities] = useState([]);

	// Document Title
	const initialTitle = "Untitled";
	const [docTitle, setDocTitle] = useState(initialTitle);

	// quill Delta Load Object
	const [loadDelta, setLoadDelta] = useState({});
	const [docId, setDocId] = useState()
	const [lastModified, setLastModified] = useState('')

	// show word and find panel 
	const [showWordCount, setShowWordCount] = useState(false)
	const [showFindnReplace, setShowFindnReplace] = useState(false)

	const [searchParams] = useSearchParams();
	
	useEffect(() => {
		let documentId = searchParams.get('_docId')
		if(!documentId) return
		setDocId(documentId)
	}, [searchParams])

	useEffect(() => {
		if (quill) {
			quill.setContents(loadDelta);
		}
	}, [quill, loadDelta]);

	
	// -------------------------------------------------------------------------

	// Save document into DB
	const saveDocument = async () => {
		let quillContent = quill.getContents();
		let savingData = JSON.stringify(quillContent);
		// console.log(savingData)
		var formdata = new FormData();
		formdata.append("file_name", docTitle);
		formdata.append("user_name", "sarvesh_iyer");
		formdata.append("store_quill_data", savingData);
		var requestOptions = {
			method: "POST",
			body: formdata,
			redirect: "follow",
		};

		let data = await fetch("http://139.59.17.33:8018/ailaysa-creator/", requestOptions);
		if (data.status === 200) {
			// const response = await data.json();
			window.alert("File Saved Successfully.");
			// console.log(data)
		}
	};

	const updateDocument = async() => {
		let quillDelta = quill.getContents();
		let updatedData = JSON.stringify(quillDelta);
		var formdata = new FormData();
		formdata.append("file_name", docTitle);
		formdata.append("user_name", "sarvesh_iyer");
		formdata.append("store_quill_data", updatedData);

		var requestOptions = {
			method: 'PUT',
			body: formdata,
			redirect: 'follow'
		};

		let data = await fetch(`http://139.59.17.33:8018/ailaysa-creator/${docId}/`, requestOptions);
		if (data.status === 200) {
			// const response = await data.json();
			window.alert("File Updated Successfully.");
			// console.log(JSON.parse(response.store_quill_data))
			// setLoadDelta(response.store_quill_data)
		}
	}


	// ------------------------------------------------------------------------------------------

	const storeDataToServer = () => {
		if (!docId) {
			saveDocument()
		} else {
			updateDocument()
		}
	}

	// --------------------------------------------------------------------------------------------


	// --------------------------------------------------------------------------------------------
	
	// NER function
	const [showNER, setShowNER] = useState(false)

	useEffect(() => {
		if (showNER) {
			findNER()
		} else {
			if (namedEntities.length) {
				namedEntities.forEach((entries) => {
					allIndex = findAllOccurrences(quillTextWithoutMedia(), entries);
					// console.log(allIndex)
					allIndex.forEach((eachIndex) => {
						// console.log(eachIndex)
						quill.formatText(eachIndex, entries.length, {
							background: "#ffffff",
						});
					});
				});
			}
		}
	}, [showNER])

	let allIndex = [];
	const findNER = async () => {
		if (quill) {
			let requestData = quillTextWithoutMedia();
			var formdata = new FormData();
			formdata.append("src_lang_code", "en");
			formdata.append("src_segment", requestData);
			// console.log(requestData)
			var requestOptions = {
				method: "POST",
				body: formdata,
				redirect: "follow",
			};

			const data = await fetch(
				"https://aidev4.ailaysa.com/nlp/ner",
				requestOptions
			);
			if (data.status === 200) {
				const response = await data.json();
				// console.log(response.src_ner);
				setNamedEntities(response.src_ner);
			}
		}
	};

	useEffect(() => {
		namedEntities.forEach((entries) => {
			allIndex = findAllOccurrences(quillTextWithoutMedia(), entries);
			// console.log(allIndex)
			allIndex.forEach((eachIndex) => {
				// console.log(eachIndex)
				quill.formatText(eachIndex, entries.length, {
					background: "#ffff00",
				});
			});
		});
	}, [namedEntities]);


// --------------------------------------------------------------------------------------------
	
	const [enableSynonym, setEnableSynonym] = useState(false)
	const [synonymText, setsynonymText] = useState('')
	const [synonymList, setSynonymList] = useState([])
	const [trigger, setTrigger] = useState(false)

	const [mclientX, setMClientX] = useState()
	const [mclientY, setMClientY] = useState()
	const [selectedTextIndex, setSelectedTextIndex] = useState()


	const getSynonymText = (e) => {
		var range = quill.getSelection();
		if (range) {
			var selectedText = quill.getText(range.index, range.length);
			setsynonymText(selectedText)
			setSelectedTextIndex(range.index)
			setTrigger(!trigger)
			// console.log(selectedText)
			setMClientX(e.clientX)
			setMClientY(e.clientY)
		}
	}

	const removeSynonymListDiv = () => {
		setSynonymList([])
		let box = document.getElementsByClassName('synonym-list-box')[0]
		box?.remove()
	}

	useEffect(() => {
		if (quill) {
			const qlEditor = document.getElementsByClassName('ql-editor')[0]
			enableSynonym && (qlEditor.addEventListener('dblclick', getSynonymText))
			enableSynonym && (qlEditor.addEventListener('click', removeSynonymListDiv))

			return () => {
				qlEditor.removeEventListener('dblclick', getSynonymText)          
				qlEditor.addEventListener('click', removeSynonymListDiv)
			}
		}
	}, [enableSynonym, synonymList.length])
	
	// console.log(trigger)

	useEffect(() => {
		// console.log(synonymText)
		async function fetchSynonym() {  
			var formdata = new FormData();
			formdata.append("text", synonymText);
			
			var requestOptions = {
				method: 'POST',
				body: formdata,
				redirect: 'follow'
			};
			if (synonymText !== '') {
				// console.log(synonymText)
				let data = await fetch("http://139.59.17.33:8018/synonyms/", requestOptions)
				if (data.status === 200) {
					const response = await data.json();
					// console.log(response.synonyms_form)
					response.synonyms_form !== undefined && (setSynonymList(response.synonyms_form))
				}
			}
		}
		fetchSynonym()
	}, [synonymText, trigger])


	useEffect(() => {
		if (quill && synonymList.length) { 
			// console.log(synonymList)
			let qlEditor = document.getElementsByClassName('ql-editor')[0]
			let rect = qlEditor.getBoundingClientRect()
			// console.log(mclientX - rect.left, mclientY - rect.top)
			let editorContainer = document.getElementsByClassName('ql-container')[0]      
			let synonymDiv = document.createElement('div')
			synonymDiv.style.position = "absolute";
			synonymDiv.style.left = mclientX - rect.left + 'px';
			synonymDiv.style.top = mclientY - rect.top + 'px';
			synonymDiv.classList.add('synonym-list-box')
			let ul = document.createElement('ul')
			// console.log(synonymText)
			synonymList.forEach((each) => {
				let li = document.createElement('li')
				let text = document.createTextNode(each)
				// console.log(selectedTextIndex)
				li.addEventListener('click', () => { replaceWithSynonym(synonymText, each, selectedTextIndex) })
				li.appendChild(text)
				ul.appendChild(li)
			})
			synonymDiv.appendChild(ul)
			editorContainer.appendChild(synonymDiv)
		}
	}, [synonymList, mclientX, mclientY, selectedTextIndex])
	
	const replaceWithSynonym = (originalText, newText, index) => {
		quill.deleteText(index, originalText.length)
		quill.insertText(index, `${newText} `)
		removeSynonymListDiv()
	}



// ---------------------------------------------------------------------------------
	// Insert Link Dialog Box

	const [caretCoordinates, setCaretCoordinates] = useState({})
	const [rangeIndex, setRangeIndex] = useState(null)
	const [selectedTextFromMenu, setSelectedTextFromMenu] = useState('')

	if (quill) {
		quill.on('selection-change', function(range, oldRange, source) {
			if (range) {
				if (range.length === 0) {
					// console.log(range.index)
					setRangeIndex(range.index)
					setCaretCoordinates(quill.getBounds(range.index))
				}else {
					setRangeIndex(range.index)
					setCaretCoordinates(quill.getBounds(range.index))
					var text = quill.getText(range.index, range.length);
					setSelectedTextFromMenu(text)
				}
			} 
		});
	}
	
	const [showLinkDialogBox, setShowLinkDialogBox] = useState(false)

	const applyLink = () => {
		let txtInput = document.getElementById('link-text').value
		let hrefInput = document.getElementById('link-href').value
		quill.insertText(rangeIndex, txtInput, 'link', hrefInput)
		setShowLinkDialogBox(false)
	}
 
	const removeInsertDialog = () => {
		let insertLinkDiv = document.getElementsByClassName('insert-link-dialog')[0]
		insertLinkDiv && insertLinkDiv.remove()
	}

	useEffect(() => {
		if (showLinkDialogBox) {
			let editorContainer = document.getElementsByClassName('ql-container')[0]      
			let insertLinkDiv = document.createElement('div')
			insertLinkDiv.classList.add('insert-link-dialog')
			insertLinkDiv.style.left = caretCoordinates.left + 'px';
			insertLinkDiv.style.top = caretCoordinates.top + 'px';
			insertLinkDiv.innerHTML += `
				<input type='text' id='link-text' placeholder='Text'/>  
				<input type='text' id='link-href' placeholder='Paste a link'/> 
				<button id='insertLinkbtn'>Insert</button>
				<button id='cancelLinkbtn'>Cancel</button>`
			editorContainer.appendChild(insertLinkDiv)
			document.getElementById('link-text').focus()
			let linkbtn = document.getElementById('insertLinkbtn')
			let cancelLink = document.getElementById('cancelLinkbtn')
			linkbtn.addEventListener('click', () => applyLink())
			cancelLink.addEventListener('click', () => setShowLinkDialogBox(false))
		} else {
			removeInsertDialog()
		}
	}, [showLinkDialogBox])


// ---------------------------------------------------------------------------------

// Spell Checker

	const [enableSpellChecker, setEnableSpellChecker] = useState(false)
	const [wrongWords, setWrongWords] = useState([])
	// const [wrongWordIndex, setWrongWordIndex] = useState([])
	useEffect(() => {
		if (enableSpellChecker) {
			async function fetchWrongWords() {  
				let checkingText = quillTextWithoutMedia()
				var formdata = new FormData();
				formdata.append("lang", "en");
				formdata.append("sentence", checkingText);
				var requestOptions = {
					method: 'POST',
					body: formdata,
					redirect: 'follow'
				};
				let data = await fetch("http://139.59.17.33:8018/hunspell_sentence_check/", requestOptions)
				if (data.status === 200) {
					const response = await data.json();
					console.log(response.word);
					setWrongWords(response.word)
				}
			}
			fetchWrongWords()
		} else {
			let ind = []
			if (wrongWords.length) {
				wrongWords.forEach((each) => {
					ind = findAllOccurrences(quillTextWithoutMedia(), each)
					ind.forEach((eh) => {
						quill.formatText(eh, each.length, {background: false})
					})
				})
			} 
		}
	}, [enableSpellChecker])
	
	useEffect(() => {
		let ind = []
		wrongWords.length && ( 
			wrongWords.forEach((each) => {
				ind = findAllOccurrences(quillTextWithoutMedia(), each)
				// setWrongWordIndex(ind)
				ind.forEach((eh) => {
				quill.formatText(eh, each.length, {background: '#ff7172'})
			})
		})
	)
	}, [wrongWords])


	useEffect(() => {
		if (quill) {
			const qlEditor = document.getElementsByClassName('ql-editor')[0]
			enableSpellChecker && qlEditor.addEventListener('dblclick', getCorrectSpell)
			enableSpellChecker && qlEditor.addEventListener('click', removeCorrectSpellListDiv)
			
			return () => {
				qlEditor.removeEventListener('dblclick', getCorrectSpell)          
				qlEditor.addEventListener('click', removeCorrectSpellListDiv)
			}
		}
	}, [enableSpellChecker, wrongWords.length])

	const [correctionWord, setCorrectionWord] = useState('')
	const [correctionWordIndex, setCorrectionWordIndex] = useState()
	const [spellCheckMouseX, setSpellCheckMouseX] = useState()
	const [spellCheckMouseY, setSpellCheckMouseY] = useState()
	const [spellCheckTrigger, setspellCheckTrigger] = useState(false)
	const [correctWordList, setCorrectWordList] = useState([])

	const getCorrectSpell = (e) => {
		var range = quill.getSelection();
		if (range) {
			var selectedText = quill.getText(range.index, range.length);
			setCorrectionWord(selectedText.trim())
			setCorrectionWordIndex(range.index)
			setspellCheckTrigger(!spellCheckTrigger)
			// console.log(selectedText)
			setSpellCheckMouseX(e.clientX)
			setSpellCheckMouseY(e.clientY)
		}
	}

	useEffect(() => {
		async function fetchCorrectWords() {  
			var formdata = new FormData();
			formdata.append("lang", "en");
			formdata.append("word", correctionWord);
			
			var requestOptions = {
				method: 'POST',
				body: formdata,
				redirect: 'follow'
			};
			if (correctionWord !== '') {
				// console.log(correctionWord)
				let data = await fetch("http://139.59.17.33:8018/hunspellcheck/", requestOptions)
				if (data.status === 200) {
					const response = await data.json();
					// console.log(response.word_suggest)
					response.word_suggest !== 'correct' && (setCorrectWordList(response.word_suggest))
				}
			}
		}
		fetchCorrectWords()
	}, [correctionWord, spellCheckTrigger])

	useEffect(() => {
		if (quill && correctWordList.length) { 
			// console.log(synonymList)
			let qlEditor = document.getElementsByClassName('ql-editor')[0]
			let rect = qlEditor.getBoundingClientRect()
			// console.log(mclientX - rect.left, mclientY - rect.top)
			let editorContainer = document.getElementsByClassName('ql-container')[0]      
			let spellCheckDiv = document.createElement('div')
			spellCheckDiv.style.position = "absolute";
			spellCheckDiv.style.left = spellCheckMouseX - rect.left + 'px';
			spellCheckDiv.style.top = spellCheckMouseY - rect.top + 'px';
			spellCheckDiv.classList.add('synonym-list-box')
			let ul = document.createElement('ul')
			// console.log(synonymText)
			correctWordList.forEach((each) => {
				let li = document.createElement('li')
				let text = document.createTextNode(each)
				// console.log(selectedTextIndex)
				li.addEventListener('click', () => { replaceWithCorrectWord(correctionWord, each, correctionWordIndex) })
				li.appendChild(text)
				ul.appendChild(li)
			})
			spellCheckDiv.appendChild(ul)
			editorContainer.appendChild(spellCheckDiv)
		}
	}, [correctWordList, spellCheckMouseX, spellCheckMouseY, selectedTextIndex])

	const replaceWithCorrectWord = (originalText, newText, index) => {
		quill.deleteText(index, originalText.length)
		quill.insertText(index, `${newText}`)
		removeCorrectSpellListDiv()
	}

	const removeCorrectSpellListDiv = () => {
		setCorrectWordList([])
		let box = document.getElementsByClassName('synonym-list-box')[0]
		box && box.remove()
	}
// ---------------------------------------------------------------------------------
// Prarphrasing

	const [showParaphrase, setShowParaphrase] = useState(null)

	const [phraseList, setphraseList] = useState([])

	const createParaphraseDropdown = () => {
		let editorContainer = document.getElementsByClassName('ql-container')[0]      
		let paraPhraseDiv = document.createElement('div')
		paraPhraseDiv.style.position = "absolute";
		paraPhraseDiv.style.left = caretCoordinates.left + 'px';
		paraPhraseDiv.style.top = caretCoordinates.top + 'px';
		paraPhraseDiv.style.width = "350px"
		paraPhraseDiv.style.transform = "translate(0%,10%)";
		paraPhraseDiv.classList.add('synonym-list-box')
		let ul = document.createElement('ul')
		let img = document.createElement('img')
		img.src = loadingImg
		img.classList.add('paraphrase-loading-img')
		console.log(img)
		ul.appendChild(img)
		paraPhraseDiv.appendChild(ul)
		editorContainer.appendChild(paraPhraseDiv)
	} 
	

	useEffect(() => {
		const getPhrases = async() => {
			let phrases = await paraPhrasing(selectedTextFromMenu)
			console.log(phrases)
			setphraseList(phrases)
		}
		if(showParaphrase !== null){
			getPhrases()
			console.log('paraphrase trigger')
		} 
	}, [showParaphrase])

	useEffect(() => {
		if (quill) {
			const qlEditor = document.getElementsByClassName('ql-editor')[0]
			showParaphrase && (qlEditor.addEventListener('click', removeSynonymListDiv))
			return () => {
				qlEditor.addEventListener('click', removeSynonymListDiv)
			}
		}
	}, [showParaphrase, phraseList.length])
	
	useEffect(() => {
		let paraphraseUl = document.querySelector('.synonym-list-box ul')
		let paraphraseLoadImg = document.querySelector('.paraphrase-loading-img')
		paraphraseLoadImg?.remove()
		phraseList.forEach((each) => {
			let li = document.createElement('li')
			let text = document.createTextNode(each)
			li.addEventListener('click', () => { replaceWithParaPhrase(selectedTextFromMenu, each, rangeIndex) })
			li.appendChild(text)
			paraphraseUl.appendChild(li)
		})
	}, [phraseList])

	const replaceWithParaPhrase = (originalText, newText, index) => {
		quill.deleteText(index, originalText.length)
		quill.insertText(index, `${newText} `)
		removeSynonymListDiv()
	}

// ---------------------------------------------------------------------------------

 // Config Shortcut Keys 
 document.onkeyup = function (e) { 
	//ctrl + shift + F for toggle find and replace panel
 if (e.ctrlKey && e.shiftKey && e.which === 70) { 
	 setShowFindnReplace(!showFindnReplace)
 }
	//ctrl + shift + L for toggle insert link dialog box
 else if (e.ctrlKey && e.shiftKey && e.which === 76) {
	 setShowLinkDialogBox(!showLinkDialogBox)
 }
	 //ctrl + / for toggle keyboard shortcut dialog box
 else if (e.ctrlKey && e.which === 191) {
	 setTargetButton('Keyboard Shortcuts')
	 setShowModal(!showModal)
 }
}

// ---------------------------------------------------------------------------------

		
	
	const [showModal, setShowModal] = useState(false);

	const [targetButton, setTargetButton] = useState(null)

	const [tempText, setTempText] = useState(null)

	const contextValue = {
		quill,
		// Quill,
		findNER,
		showNER,
		setShowNER,
		saveDocument,
		docTitle,
		setDocTitle,
		docId,
		setDocId,
		enableSynonym,
		setEnableSynonym,
		storeDataToServer,
		showWordCount,
		setShowWordCount,
		showFindnReplace,
		setShowFindnReplace,
		showLinkDialogBox,
		setShowLinkDialogBox,
		enableSpellChecker,
		setEnableSpellChecker,
		showModal,
		setShowModal,
		targetButton,
		setTargetButton,
		quillTextWithoutMedia,
		selectedTextFromMenu,
		setSelectedTextFromMenu,
		tableObj,
		setLastModified,
		lastModified,
		tempText,
		setTempText,
		rangeIndex,
		setShowParaphrase,
		showParaphrase,
		createParaphraseDropdown
	}

	const handleOnClick = (e) => {
		console.log(quill)
		var range = quill.getSelection()
		let bounds = quill.getBounds(range.index, range.length)
		let quillContainer = document.querySelector('.ql-container')
		let div = document.createElement('div')
		div.classList.add('temp-box')
		div.style.top = `${bounds.top}px`
		div.style.left = `${bounds.left}px`
		console.log(bounds.top)
		console.log(bounds.left)

		quillContainer.prepend(div)


	} 

	return (
		<div>
			<div>
				<stateContext.Provider value={contextValue}>
					<EditorHeader />
					<div className="editor-container" >
								<div>
										<div ref={quillRef} spellCheck="false" />
								</div>
						<FindandReplace />
						{
							showModal ? <Modal /> : null
						}
					</div>
				</stateContext.Provider>
					{
						showWordCount ? <WordCount quill={quill} /> : null
					}
					
				</div>
			</div>
	);
};
